<ng-container *ngIf="loading; else dataBlock">
  <div class="loading-page">
    <div class="loading-spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </div>
</ng-container>

<ng-template #dataBlock>
  <div class="table-flex__item" *ngIf="tree">
    <div class="table-flex__row bg-gray--250">
      <p class="w-25">{{ contractCode }} - {{ contractName }}</p>
      <p class="w-10">Todos</p>

      <p class="w-15">
        <a class="no-href" *ngIf="tree.quantityInProcessing !== '0/0.00%'"
          (click)="filterNavigate('by-date', 'inProcess')">
          {{ tree.quantityInProcessing }}
        </a>
        <ng-container
          *ngIf="tree.quantityInProcessing === '0/0.00%'">0</ng-container>
      </p>

      <p class="w-15">
        <a class="no-href" *ngIf="tree.validQuantity > 0"
          (click)="filterNavigate('by-date', 'valid')">
          {{ formatQty(tree.validQuantity, tree.total) }}
        </a>
        <ng-container *ngIf="tree.validQuantity === 0">0</ng-container>
      </p>

      <p class="w-15">
        <a class="no-href" *ngIf="tree.invalidQuantity > 0"
          (click)="filterNavigate('by-date', 'invalid')">
          {{ formatQty(tree.invalidQuantity, tree.total) }}
        </a>
        <ng-container *ngIf="tree.invalidQuantity === 0">0</ng-container>
      </p>

      <p class="w-10">
        <a class="no-href" (click)="filterNavigate('by-date')">
          {{ tree.total }}
        </a>
      </p>

      <p class="w-10">
        <button class="btn btn-sm btn-icon-block" i18n-appTooltip
          appTooltip="Expandir/Retrair todos"
          [ngClass]="{ 'btn-secondary': allCollapse, 'btn-outline-secondary': !allCollapse }"
          (click)="toggleAllCollapse()" *ngIf="tree.total > 0">
          <i class="material-icons" *ngIf="allCollapse">unfold_less</i>
          <i class="material-icons" *ngIf="!allCollapse">unfold_more</i>
        </button>
      </p>
    </div>

    <div class="table-flex__item" *ngFor="let spot of tree?.spotsPaged"
      [class.collapsed]="spot.collapse">
      <div class="table-flex__row bg-gray--200">
        <p class="w-25 w--push-3" i18n-appTooltip
          [appTooltip]="'Ponto: ' + spot.spotCode + ' - ' + spot.spotDescription">
          {{ spot.spotCode }} {{ (spot.spotDescription?.length > 20)? ' - ' +
          (spot.spotDescription | slice:0:20) + '...' : ' - ' +
          (spot.spotDescription || '') }}
        </p>
        <p class="w-10"></p>

        <p class="w-15">
          <a class="no-href" *ngIf="spot.quantityInProcessing !== '0/0.00%'"
            (click)="filterNavigate('by-date', 'inProcess', null, spot.spotId)">
            {{ spot.quantityInProcessing }}
          </a>
          <ng-container
            *ngIf="spot.quantityInProcessing === '0/0.00%'">0</ng-container>
        </p>

        <p class="w-15">
          <a class="no-href" *ngIf="spot.validQuantity > 0"
            (click)="filterNavigate('by-date', 'valid', null, spot.spotId)">
            {{ formatQty(spot.validQuantity, spot.total) }}
          </a>
          <ng-container *ngIf="spot.validQuantity === 0">0</ng-container>
        </p>

        <p class="w-15">
          <a class="no-href" *ngIf="spot.invalidQuantity > 0"
            (click)="filterNavigate('by-date', 'invalid', null, spot.spotId)">
            {{ formatQty(spot.invalidQuantity, spot.total) }}
          </a>
          <ng-container *ngIf="spot.invalidQuantity === 0">0</ng-container>
        </p>

        <p class="w-10">
          <a class="btn btn-no-href"
            (click)="filterNavigate('by-date', null, null, spot.spotId)">{{
            spot.total
            }}</a>
        </p>

        <div class="w-10 text-center">
          <button class="btn btn-sm btn-icon-block"
            [ngClass]="{ 'btn-secondary': spot.collapse, 'btn-outline-secondary': !spot.collapse }"
            (click)="toggleCollapse(spot)" *ngIf="spot.total > 0">
            <i class="material-icons" *ngIf="spot.collapse">unfold_less</i>
            <i class="material-icons" *ngIf="!spot.collapse">unfold_more</i>
          </button>
        </div>
      </div>

      <ng-container *ngIf="!spot.collapse">
        <div class="table-flex__item"
          *ngFor="let lane of spot?.lanes">
          <div class="table-flex__row bg-gray--100">
            <p class="w-25 w--push-5" i18n-appTooltip
              [appTooltip]="lane?.laneCode + '- Fx' + lane?.laneNumber + '(Ponto ' + spot?.spotCode +')'">
              {{ lane?.laneCode }} - Fx {{lane?.laneNumber}} (Ponto {{
              spot?.spotCode
              }})
            </p>
            <p class="w-10">
              <button class="btn btn-sm btn-icon-block"
                (click)="toggleCollapse(lane)" *ngIf="lane.total > 0">
                <i class="material-icons" *ngIf="lane.collapse">expand_more</i>
                <i class="material-icons" *ngIf="!lane.collapse">expand_less</i>
              </button>
            </p>

            <p class="w-15">
              <a class="no-href" *ngIf="lane.quantityInProcessing !== '0/0.00%'"
                (click)="filterNavigate('details', 'inProcess', null, spot.spotId, lane.laneId)">
                {{ lane.quantityInProcessing }}
              </a>
              <ng-container
                *ngIf="lane.quantityInProcessing === '0/0.00%'">0</ng-container>
            </p>

            <p class="w-15">
              <a class="no-href" *ngIf="lane.validQuantity > 0"
                (click)="filterNavigate('details', 'valid', null, spot.spotId, lane.laneId)">
                {{ formatQty(lane.validQuantity, lane.total) }}
              </a>
              <ng-container *ngIf="lane.validQuantity === 0">0</ng-container>
            </p>

            <p class="w-15">
              <a class="no-href" *ngIf="lane.invalidQuantity > 0"
                (click)="filterNavigate('details', 'invalid', null, spot.spotId, lane.laneId)">
                {{ formatQty(lane.invalidQuantity, lane.total) }}
              </a>
              <ng-container *ngIf="lane.invalidQuantity === 0">0</ng-container>
            </p>

            <p class="w-10"><a class="btn btn-no-href"
                (click)="filterNavigate('by-date', null, null, spot.spotId, lane.laneId)">{{
                lane.total }}</a></p>
            <p class="w-10"></p>
          </div>

          <ng-container *ngIf="!lane.collapse">
            <div class="table-flex__item" *ngFor="let reg of lane.regulations">
              <div class="table-flex__row">
                <p class="w-25"></p>
                <p class="w-10">
                  <span i18n-appTooltip [appTooltip]="reg.regulationDescription"
                    class="d-inline-flex align-items-center">
                    <i class="material-icons text-light mr-2">info</i>
                    {{ reg.regulationCode }}
                  </span>
                </p>

                <p class="w-15">
                  <a class="no-href"
                    *ngIf="reg.quantityInProcessing !== '0/0.00%'"
                    (click)="filterNavigate('by-date', 'inProcess', reg.regulationId, spot.spotId, lane.laneId)">
                    {{ reg.quantityInProcessing }}
                  </a>
                  <ng-container
                    *ngIf="reg.quantityInProcessing === '0/0.00%'">0</ng-container>
                </p>

                <p class="w-15">
                  <a class="no-href" *ngIf="reg.validQuantity > 0"
                    (click)="filterNavigate('by-date', 'valid', reg.regulationId, spot.spotId, lane.laneId)">
                    {{ formatQty(reg.validQuantity, reg.total) }}
                  </a>
                  <ng-container *ngIf="reg.validQuantity === 0">0</ng-container>
                </p>

                <p class="w-15">
                  <a class="no-href" *ngIf="reg.invalidQuantity > 0"
                    (click)="filterNavigate('by-date', 'invalid', reg.regulationId, spot.spotId, lane.laneId)">
                    {{ formatQty(reg.invalidQuantity, reg.total) }}
                  </a>
                  <ng-container
                    *ngIf="reg.invalidQuantity === 0">0</ng-container>

                  <button class="btn btn-sm btn-icon-block"
                    (click)="toggleCollapse(reg)"
                    *ngIf="reg.invalidQuantity > 0">
                    <i class="material-icons"
                      *ngIf="reg.collapse">expand_more</i>
                    <i class="material-icons"
                      *ngIf="!reg.collapse">expand_less</i>
                  </button>
                </p>

                <p class="w-10"><a class="btn btn-no-href"
                    (click)="filterNavigate('by-date', null, reg.regulationId, spot.spotId, lane.laneId)">{{
                    reg.total }}</a></p>
                <p class="w-10"></p>
              </div>

              <ng-container *ngIf="!reg.collapse && reg.reasons">
                <div class="table-flex__row" *ngFor="let reason of reg.reasons">
                  <p class="w-25"></p>
                  <p class="w-10"></p>
                  <p class="w-15"></p>
                  <p class="w-15"></p>
                  <p class="w-15">{{ reason.reasonCode }} - {{
                    reason.reasonDescription }}</p>
                  <p class="w-10">
                    <a class="btn btn-no-href"
                      (click)="filterNavigate('by-date', null, reg.regulationId, spot.spotId, lane.laneId, reason.reasonId)">
                      {{ reason.total }}
                    </a>
                  </p>
                  <div class="w-10 pr-3">
                    <div class="progress" i18n-appTooltip
                      [appTooltip]="'Representa ' + getProgressWidth(reason.invalidQuantity, reg.invalidQuantity) + ' das inválidas desta regra'">
                      <div class="progress-bar bg-info" role="progressbar"
                        [style.width]="getProgressWidth(reason.invalidQuantity, reg.invalidQuantity)"
                        [attr.aria-valuenow]="reason.invalidQuantity"
                        aria-valuemin="0"
                        [attr.aria-valuemax]="reg.invalidQuantity">
                        {{ getProgressWidth(reason.invalidQuantity,
                        reg.invalidQuantity) }}
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>

            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
    <app-pagination-simple
      [data]="tree?.spots"
      (items)="tree.spotsPaged = $event">
    </app-pagination-simple>
  </div>

  <div *ngIf="!tree" class="text-center p-4">
    Nenhum dado encontrado para o período selecionado.
  </div>
</ng-template>
